import { createStore, combineReducers, applyMiddleware } from "redux";
import { composeWithDevTools } from "redux-devtools-extension";
import thunk from "redux-thunk";

//Super Admin Reducers
import { getPublicSubscriptionReducers } from "./reducer/super-admin";

//Admin Reducers
import * as reducer_1 from "./reducer";

import * as manager from "./reducer/manager";

//User Reducers
import * as user from "./reducer/user";
import { SHARED_LOGOUT } from "./types/shared/authTypes";
import { ADMIN_OPEN_ANOTHER_COMPANY_LIST_SUCCESS } from "./types/admin/employessTypes";
import { initialTheme } from "./reducer/admin/themeReducer";
import {
  getAllModulesReducer,
  saveEntityModulesReducer,
  getEntityModulesReducer,
} from "./reducer/admin/moduleReducers";

const reducer = combineReducers({
  //admin
  adminLogin: reducer_1.adminLoginReducers,
  adminRegister: reducer_1.adminRegisterReducers,
  adminRegisterSuper: reducer_1.adminRegisterSuperReducers,
  empLists: reducer_1.empListReducers,
  userIdScreenLists: reducer_1.screenShotReducers,
  userIdProductLists: reducer_1.productReducers,
  userIdMonthProduct: reducer_1.productMonthReducers,
  createCompany: reducer_1.createCompanyReducers,
  sendOtpForgetPassword: reducer_1.sendOtpForgetPasswordReducer,
  getDepartmentList: reducer_1.getDepartmentListReducers,
  updatePassword: reducer_1.updatePasswordReducer,
  activeSubscription: reducer_1.activeSubscriptionReducers,
  sharedLogin: reducer_1.sharedLoginReducers,
  adminSideTodayTimer: reducer_1.todayTimerReducer,
  adminSideMonthTimer: reducer_1.monthTimerReducer,
  empUserId: reducer_1.empUserIdReducers,
  userInviteRegister: reducer_1.userInviteRegisterReducers,
  inviteEmailList: reducer_1.inviteEmailListReducers,
  addDepartmentList: reducer_1.addDepartmentReducers,
  deleteDepartmentList: reducer_1.deleteDepartmentReducers,
  addGoalsList: reducer_1.addGoalsReducers,
  prevTimerList: reducer_1.prevTimerReducer,
  prevProductList: reducer_1.prevProductReducers,
  todoLists: reducer_1.todoReducer,
  todoTimerList: reducer_1.todoTimerReducer,
  todayTodoCompletedList: reducer_1.todayTodoCompletedReducer,
  prevTodoCompletedList: reducer_1.prevTodoCompletedReducer,
  todoMothTimerList: reducer_1.todoMothTimerReducer,
  ProjectLists: reducer_1.ProjectReducer,
  projectMothTimerList: reducer_1.projectMothTimerReducer,
  projectTimerList: reducer_1.projectTimerReducer,
  addUserInDepartmentList: reducer_1.addUserInDepartmentReducers,
  ProjectAllList: reducer_1.ProjectAllReducer,
  todoCompleteList: reducer_1.todoCompleteReducer,
  todoInCompleteList: reducer_1.todoInCompleteReducer,
  getUserFromDepartmentList: reducer_1.getUserFromDepartmentReducers,
  empInviteByEmailList: reducer_1.empInviteByEmailReducers,
  adminUpdateDetailList: reducer_1.adminUpdateDetailReducers,
  adminChangePasswordList: reducer_1.adminChangePasswordReducers,
  adminChangeImageList: reducer_1.adminChangeImageReducers,
  adminPersonalLists: reducer_1.adminPersonalReducers,
  getAdminPersonalLists: reducer_1.getAdminPersonalReducers,
  updateCompanyList: reducer_1.updateCompanyReducers,
  updateCompanyLogoList: reducer_1.updateCompanyLogoReducers,
  empAllScreenList: reducer_1.empAllScreenReducers,
  empAllList: reducer_1.empAllReducers,
  todayAllTimerList: reducer_1.todayAllTimerReducer,
  productAllTodayList: reducer_1.productAllTodayReducers,
  monthAllTimerList: reducer_1.monthAllTimerReducer,
  productAllMonthList: reducer_1.productAllMonthReducers,
  projectAllDatedTimerList: reducer_1.projectAllDatedTimerReducer,
  todoTimeUserIdAllList: reducer_1.todoTimeUserIdAllReducer,
  todoUserIdAllCompleteList: reducer_1.todoUserIdAllCompleteReducer,
  todoUserIdAllInCompleteList: reducer_1.todoUserIdAllInCompleteReducer,
  todayTimerForReportList: reducer_1.todayTimerForReportReducer,
  todayProductivityForReportList: reducer_1.todayProductivityForReportReducers,
  todoRangeTimerList: reducer_1.todoRangeTimerReducer,
  projectRangeTimerList: reducer_1.projectRangeTimerReducer,
  empAllActivityList: reducer_1.empAllActivityReducers,
  empAllReportLists: reducer_1.empAllReportReducers,
  empAllTimesheetList: reducer_1.empAllTimesheetReducers,
  empAddTimeInProjectList: reducer_1.empAddTimeInProjectReducers,
  empAllTeamsList: reducer_1.empAllTeamsReducers,
  editDepartmentList: reducer_1.editDepartmentReducers,
  empAddInProjectIdList: reducer_1.empAddInProjectIdReducers,
  empAddInProjectList: reducer_1.empAddInProjectReducers,
  empAllCheckinList: reducer_1.empAllCheckinReducers,
  empEditTimeInProjectList: reducer_1.empEditTimeInProjectReducers,
  empTimeProDasboardDateList: reducer_1.empTimeProDasboardDateReducers,
  empTimeProDasboardWeekList: reducer_1.empTimeProDasboardWeekReducers,
  empTimeProDasboardSevenList: reducer_1.empTimeProDasboardSevenReducers,
  trailSubscriptionList: reducer_1.trailSubscriptionReducers,
  projectDeleteList: reducer_1.projectDeleteReducer,
  projectTimeDeleteList: reducer_1.projectTimeDeleteReducer,
  empBlockFromCompanyList: reducer_1.empBlockFromCompanyReducers,
  empDeleteFromCompanyList: reducer_1.empDeleteFromCompanyReducers,
  empBlockFromDepartmentList: reducer_1.empBlockFromDepartmentReducers,
  empUpdatDetailList: reducer_1.empUpdatDetailReducers,
  empDeleteProjectTimeList: reducer_1.empDeleteProjectTimeReducers,
  sendEmpResetPassEmailList: reducer_1.sendEmpResetPassEmailReducers,
  deleteEmpScreenShotList: reducer_1.deleteEmpScreenShotReducers,
  updateEmpScreenShotList: reducer_1.updateEmpScreenShotReducers,
  addUserInDepartmentWithProList: reducer_1.addUserInDepartmentWithProReducers,
  userInviteRegisterByEmailList: reducer_1.userInviteRegisterByEmailReducers,
  adminResendEmailList: reducer_1.adminResendEmailReducers,
  getCompanySettingList: reducer_1.getCompanySettingReducers,
  idleSettingList: reducer_1.idleSettingReducers,
  idleTimeSettingList: reducer_1.idleTimeSettingReducers,
  notificationSettingList: reducer_1.notificationSettingReducers,
  screenshotLimitSettingList: reducer_1.screenshotLimitSettingReducers,
  weeklyLimitSettingList: reducer_1.weeklyLimitSettingReducers,
  timeHeroSettingList: reducer_1.timeHeroSettingReducers,
  AddCompanySettingList: reducer_1.AddCompanySettingReducers,
  AddIdleTimeCompanySettingList: reducer_1.AddIdleTimeCompanySettingReducers,
  AddScreenshotCompanySettingList:
    reducer_1.AddScreenshotCompanySettingReducers,
  AddTimeHeroCompanySettingList: reducer_1.AddTimeHeroCompanySettingReducers,
  AddWeeklyLimitCompanySettingList:
    reducer_1.AddWeeklyLimitCompanySettingReducers,
  getAllCompanySettingList: reducer_1.getAllCompanySettingReducers,
  empUpdatTypeList: reducer_1.empUpdatTypeReducers,
  companyUserTypeSettingList: reducer_1.companyUserTypeSettingReducers,
  getCompAppTrackByDateList: reducer_1.getCompAppTrackByDateReducers,
  userAppTrackSettingList: reducer_1.userAppTrackSettingReducers,
  companyUserAppTrackSettingList: reducer_1.companyUserAppTrackSettingReducers,
  getEmpTotalTimeByRangeList: reducer_1.getEmpTotalTimeByRangeReducers,
  userPayRateSettingList: reducer_1.userPayRateSettingReducers,
  addEmployeeExtraInfoList: reducer_1.addEmployeeExtraInfoReducers,
  addEmployeeExtraSocialList: reducer_1.addEmployeeExtraSocialReducers,
  // addEmployeeExtraWorkList: reducer_1.addEmployeeExtraWorkReducers,
  getEmployeeExtraInfoList: reducer_1.getEmployeeExtraInfoReducers,
  addEmployeeProfileImageList: reducer_1.addEmployeeProfileImageReducers,
  addEmployeeExtraPersonalInfoList:
    reducer_1.addEmployeeExtraPersonalInfoReducers,
  addEmployeesAssetList: reducer_1.addEmployeesAssetReducers,
  updateEmployeesAssetList: reducer_1.updateEmployeesAssetReducers,
  // updateEmployeesArchivedAssetList:
  //   reducer_1.updateEmployeesArchivedAssetReducers,
  updateEmpFrontDocList: reducer_1.updateEmpFrontDocReducers,
  updateEmpBackDocList: reducer_1.updateEmpBackDocReducers,
  updateEmpOtherDocList: reducer_1.updateEmpOtherDocReducers,
  updateEmpPassPortList: reducer_1.updateEmpPassPortReducers,
  archivedEmpOtherDocList: reducer_1.archivedEmpOtherDocReducers,
  addAnnouncementList: reducer_1.addAnnouncementReducer,
  deleteAnnouncementList: reducer_1.deleteAnnouncementReducer,
  getAnnouncementList: reducer_1.getAnnouncementReducer,
  userDeleteFromProjectList: reducer_1.userDeleteFromProjectReducer,
  userWorkingSettingList: reducer_1.userWorkingSettingReducers,
  addEmployeesExpenseList: reducer_1.addEmployeesExpenseReducers,
  updateEmployeesArchivedExpenseList:
    reducer_1.updateEmployeesArchivedExpenseReducers,
  updateEmployeesExpenseList: reducer_1.updateEmployeesExpenseReducers,
  adminOnBoardList: reducer_1.adminOnBoardReducers,
  addApproveLeaveList: reducer_1.addApproveLeaveReducers,
  addLeaveLists: reducer_1.addLeaveReducers,
  addRejectLeaveList: reducer_1.addRejectLeaveReducers,
  deleteLeaveList: reducer_1.deleteLeaveReducers,

  getAllLeaveHistoryList: reducer_1.getAllLeaveHistoryReducer,
  getAllLeaveRequestsList: reducer_1.getAllLeaveRequestsReducer,

  getLeaveByCompanyList: reducer_1.getLeaveByCompanyReducers,
  getLeaveByIdList: reducer_1.getLeaveByIdReducers,
  addCompanyLeaveSettingList: reducer_1.addCompanyLeaveSettingReducers,
  getCompanyLeaveSettingList: reducer_1.getCompanyLeaveSettingReducers,
  addUserLeaveSettingList: reducer_1.addUserLeaveSettingReducers,
  addWorkingIneaveSettingList: reducer_1.addWorkingIneaveSettingReducers,
  addCompanyWorkingPolicyList: reducer_1.addCompanyWorkingPolicyReducers,
  addApproveLeaveSettingList: reducer_1.addApproveLeaveSettingsReducers,
  addExcludeLeaveSettingList: reducer_1.addExcludeLeaveSettingsReducers,
  archivedCompanyPayrollCompSettingsList:
    reducer_1.archivedCompanyPayrollCompSettingsReducers,
  addCompanyPayrollCompSettingsList:
    reducer_1.addCompanyPayrollCompSettingsReducers,
  getCompanyPayrollCompSettingsList:
    reducer_1.getCompanyPayrollCompSettingsReducers,
  addCompanyPayrollBasicSettingsList:
    reducer_1.addCompanyPayrollBasicSettingsReducers,
  getAllCompanyList: reducer_1.getAllCompanyReducers,
  openAnotherCompanyList: reducer_1.openAnotherCompanyReducers,
  adminArchiveCompanyList: reducer_1.adminArchiveCompanyReducers,
  adminAddUserImportCompanyList: reducer_1.adminAddUserImportCompanyReducers,
  leaveCategoryImportList: reducer_1.leaveCategoryImportReducer,
  userQuotaImportList: reducer_1.userQuotaImportReducer,
  shiftImportList: reducer_1.shiftImportReducer,
  adminCheckUserImportCompanyList:
    reducer_1.adminCheckUserImportCompanyReducers,
  addShiftManagementCompanyList: reducer_1.addShiftManagementCompanyReducers,
  addShiftManagementUserIdCompanyList:
    reducer_1.addShiftManagementUserIdCompanyReducers,
  getShiftManagementCompanyList: reducer_1.getShiftManagementCompanyReducers,
  empFilterList: reducer_1.empFilterReducers,
  downloadShiftsFile: reducer_1.downloadShiftsReducer,
  shiftManageInfo: reducer_1.shiftManagementReducer,
  addApplicationDocList: reducer_1.addApplicationDocReducers,
  addPassportDocList: reducer_1.addPassportDocReducers,
  addVisaDocList: reducer_1.addVisaDocReducers,
  addDocumentCompanySettingsList: reducer_1.addDocumentCompanySettingsReducers,
  addManyUserIdInShiftManageCompanyList:
    reducer_1.addManyUserIdInShiftManageCompanyReducers,
  adminAddUserInDepartImportCompanyList:
    reducer_1.adminAddUserInDepartImportCompanyReducers,
  adminCheckUserInDepartImportCompanyList:
    reducer_1.adminCheckUserInDepartImportCompanyReducers,
  adminAddUserLeaveDaysImportCompanyList:
    reducer_1.adminAddUserLeaveDaysImportCompanyReducers,
  adminCheckUserLeaveDaysImportCompanyList:
    reducer_1.adminCheckUserLeaveDaysImportCompanyReducers,
  adminAddUserCheckInOutImportCompanyList:
    reducer_1.adminAddUserCheckInOutImportCompanyReducers,
  adminAddUserLeavesImportCompanyList:
    reducer_1.adminAddUserLeavesImportCompanyReducers,
  adminCheckUserCheckInOutImportCompanyList:
    reducer_1.adminCheckUserCheckInOutImportCompanyReducers,
  adminCheckUserLeavesImportCompanyList:
    reducer_1.adminCheckUserLeavesImportCompanyReducers,
  getWorkBreakCompanyList: reducer_1.getWorkBreakCompanyReducers,
  addWorkBreakCompanyList: reducer_1.addWorkBreakCompanyReducers,
  addUserInWorkBreakList: reducer_1.addUserInWorkBreakReducers,
  removeUserInWorkBreakList: reducer_1.removeUserInWorkBreakReducers,
  addCompanySalarySettingsList: reducer_1.addCompanySalarySettingsReducers,
  archivedCompanySalaryCompSettingsList:
    reducer_1.archivedCompanySalaryCompSettingsReducers,
  addCompSalarySettingsList: reducer_1.addCompSalarySettingsReducers,
  deleteCompSalarySettingsList: reducer_1.deleteCompSalarySettingsReducers,
  addTrainingList: reducer_1.addTrainingReducer,
  getTrainingList: reducer_1.getTrainingReducer,
  deleteTrainingList: reducer_1.deleteTrainingReducer,
  specificTraining: reducer_1.getSpecificTrainingReducer,
  addDepartInTrainingList: reducer_1.addDepartInTrainingReducer,
  addUsersInTrainingList: reducer_1.addUsersInTrainingReducer,
  addModuleInTrainingList: reducer_1.addModuleInTrainingReducer,
  addQuizInTrainingList: reducer_1.addQuizInTrainingReducer,
  addSectionInTrainingList: reducer_1.addSectionInTrainingReducer,
  editQuizInTrainingList: reducer_1.editQuizInTrainingReducer,
  editQuizNameInTrainingList: reducer_1.editQuizNameInTrainingReducer,
  archivedCompanyTaxSettingsList: reducer_1.archivedCompanyTaxSettingsReducers,
  addEmpEmiratesIdDocList: reducer_1.addEmpEmiratesIdDocReducers,
  addEmpEducationDocList: reducer_1.addEmpEducationDocReducers,
  addEmpInsuranceDocList: reducer_1.addEmpInsuranceDocReducers,
  addEmpCheckinList: reducer_1.addEmpCheckinReducers,
  deleteEmpCheckinList: reducer_1.deleteEmpCheckinReducers,
  resendOtpBySmsList: reducer_1.resendOtpBySmsReducers,
  confirmSignUpOtpBySmsList: reducer_1.confirmSignUpOtpBySmsReducers,
  resendSignUpOtpBySmsList: reducer_1.resendSignUpOtpBySmsReducers,
  updateOtpBySmsList: reducer_1.updateOtpBySmsReducers,
  regenrateTokenList: reducer_1.regenrateTokenReducers,
  loginUsingTokenList: reducer_1.loginUsingTokenReducers,
  getEmpPayrollList: reducer_1.getEmpPayrollReducers,
  updateEmpPayrollList: reducer_1.updateEmpPayrollReducers,
  updateEmpPayrollCategoryList: reducer_1.updateEmpPayrollCategoryReducers,
  addMainPayrollOfCompanyList: reducer_1.addMainPayrollOfCompanyReducers,
  firstCategoryList: reducer_1.firstCategoryReducer,
  addGeneratePayrollOfCompanyList:
    reducer_1.addGeneratePayrollOfCompanyReducers,
  getEmpPayrollTimeRecordList: reducer_1.getEmpPayrollTimeRecordReducers,
  AddDataInPayrollList: reducer_1.AddDataInPayrollReducer,
  addPayrollAdditionsList: reducer_1.addPayrollAdditionsReducer,
  addSalaryBreakDownList: reducer_1.addSalaryBreakDownReducers,
  addSalaryBreakDownByUserList: reducer_1.addSalaryBreakDownByUserReducers,
  createServiceRequestList: reducer_1.createServiceRequestReducer,
  deleteServiceRequestList: reducer_1.deleteServiceRequestReducer,
  approveServiceRequestList: reducer_1.approveServiceRequestReducer,
  rejectServiceRequestList: reducer_1.rejectServiceRequestReducer,
  getServiceRequestList: reducer_1.getServiceRequestReducer,
  archiveServiceRequestList: reducer_1.archiveServiceRequestReducer,
  addImportPayrollProcessList: reducer_1.addImportPayrollProcessReducer,
  addImportAdditionalList: reducer_1.addImportAdditionalReducer,
  addImportReviewList: reducer_1.addImportReviewReducer,
  getHrmCheckinList: reducer_1.getHrmCheckinReducers,
  getAllDocsList: reducer_1.getAllDocsReducers,
  employeeCheckinRangeReportList: reducer_1.employeeCheckinRangeReportReducers,
  getPublicSubscription: getPublicSubscriptionReducers,
  getUserLogList: reducer_1.getUserLogReducer,
  addLabourDocList: reducer_1.addLabourDocReducers,
  getAllBankAccountsList: reducer_1.getAllBankAccountsReducers,
  createBankAccountList: reducer_1.createBankAccountReducers,
  editBankAccountList: reducer_1.editBankAccountReducers,
  salaryCSVList: reducer_1.salaryCSVReducers,
  createAirTicketList: reducer_1.createAdminAirTicketReducer,
  deleteAirTicketList: reducer_1.deleteAdminAirTicketReducer,
  getAirTicketList: reducer_1.getAdminAirTicketReducer,
  updateAirTicketList: reducer_1.updateAdminAirTicketReducer,
  addEmpAirReimburstDocList: reducer_1.addEmpAirReimburstDocReducers,
  addNewEmployeeList: reducer_1.addNewEmployeeReducers,
  editEmployeeList: reducer_1.editEmployeeReducers,
  editTeamList: reducer_1.editTeamReducers,
  createGeoFenceList: reducer_1.createAdminGeoFenceReducer,
  addEmpGeoFenceList: reducer_1.addEmpAdminGeoFenceReducer,
  deleteGeoFenceList: reducer_1.deleteAdminGeoFenceReducer,
  getGeoFenceList: reducer_1.getAdminGeoFenceReducer,
  updateManyStatusInShiftManageCompanyList:
    reducer_1.updateManyStatusInShiftManageCompanyReducers,
  RemoveUserFromShiftCompanyList: reducer_1.RemoveUserFromShiftCompanyReducers,
  updateStatusSingleShiftList: reducer_1.updateStatusSingleShiftReducers,
  updateStatusTemplateShiftList: reducer_1.updateStatusTemplateShiftReducers,
  updateWeekTemplateShiftList: reducer_1.updateWeekTemplateShiftReducers,
  addManyInShiftWeekTemplateList: reducer_1.addManyInShiftWeekTemplateReducers,
  deleteManyInShiftWeekTemplateList:
    reducer_1.deleteManyInShiftWeekTemplateReducers,
  empAllTimesheetForHrmList: reducer_1.empAllTimesheetForHrmReducers,
  empAllNewTimesheetList: reducer_1.empAllNewTimesheetReducers,
  empSingleNewTimesheetList: reducer_1.empSingleNewTimesheetReducers,
  empAllNewTimesheetStatsList: reducer_1.empAllNewTimesheetStatsReducers,
  empSingleNewTimesheetStatsList: reducer_1.empSingleNewTimesheetStatsReducers,
  empOvertimeList: reducer_1.empOvertimeReducers,
  changeStatusOfTimesheetBySingleList:
    reducer_1.changeStatusOfTimesheetBySingleReducers,
  changeStatusOfTimesheetByRangeList:
    reducer_1.changeStatusOfTimesheetByRangeReducers,
  changeManyEmpStatusOfTimesheetByRangeList:
    reducer_1.changeManyEmpStatusOfTimesheetByRangeReducers,
  addCompanyTaxSettingsList: reducer_1.addCompanyTaxSettingsReducers,
  getOffBoardingUserDataList: reducer_1.getOffBoardingUserDataReducers,
  addOffBoardingDataList: reducer_1.addOffBoardingDataReducers,
  AddOffBoardingList: reducer_1.AddOffBoardingReducer,
  getOffBoardingAllDataList: reducer_1.getOffBoardingAllDataReducers,
  getAnotherCompanySalaryBreakDownList:
    reducer_1.getAnotherCompanySalaryBreakDownReducers,
  addAppraisalDataList: reducer_1.addAppraisalDataReducers,
  addTransferDataList: reducer_1.addTransferDataReducers,
  addMoveDataList: reducer_1.addMoveDataReducers,
  updateUserLeaveSettingList: reducer_1.updateUserLeaveSettingReducers,
  setApproverStagesForLeaveSettingList:
    reducer_1.setApproverStagesForLeaveReducers,
  setApproverStagesForLeaveDepartmentList:
    reducer_1.setApproverStagesForLeaveDepartmentReducers,
  uploadPayslipsList: reducer_1.uploadPayslipsReducers,
  createGenerateInUploadPayslipsList:
    reducer_1.createGenerateInUploadPayslipsReducers,
  editUploadPayslipsList: reducer_1.editUploadPayslipsReducers,
  adminDynamicDocumentsImportCompanyList:
    reducer_1.adminDynamicDocumentsImportCompanyReducers,
  searchbarDataList: reducer_1.searchbarDataReducers,
  //user
  getUserServiceRequestList: user.getUserServiceRequestReducer,
  createUserServiceRequestList: user.createUserServiceRequestReducer,
  deleteUserServiceRequestList: user.deleteUserServiceRequestReducer,
  userRegister: user.userRegisterReducers,
  userLogin: user.userLoginReducers,
  screenLists: user.screenReducers,
  userProductLists: user.userProductReducers,
  addCompany: user.addCompanyReducers,
  MyDepartReducers: user.getMyDepartReducers,
  getMyCompanies: user.getMyCompaniesReducers,
  userMonthProduct: user.userMonthProductReducers,
  userTime: user.timeReducer,
  userMonthTime: user.userMonthTimeReducer,
  completedTodoList: user.completedTodoReducers,
  completeTimeTodoList: user.completedTimeTodoReducers,
  userProjectList: user.userProjectReducers,
  timePrevList: user.timePrevReducer,
  userPrevProductList: user.userPrevProductReducers,
  completedPrevTodoList: user.completedPrevTodoReducers,
  getDepartList: user.getDepartReducers,
  getDepartUsersList: user.getDepartUsersReducers,
  inCompleteTodoList: user.inCompletedTodoReducers,
  CompletedTotalTodoList: user.CompletedTotalTodoReducers,
  monthTodoTimeList: user.monthTodoTimeReducers,
  TotalTodoList: user.TotalTodoReducers,
  userProjectTimeDateList: user.userProjectTimeDateReducers,
  userDetailList: user.userDetailReducers,
  userChangePasswordList: user.userChangePasswordReducers,
  userPersonalLists: user.userPersonalReducers,
  getAllUserCompanyList: user.getAllCompaniesReducers,
  userPersonalList: user.getUserPersonalReducers,
  userUpdateProfilePicList: user.userUpdateProfilePicReducers,
  TodayTodoList: user.TodayTodoReducers,
  userProjectAddTimeList: user.userProjectAddTimeReducers,
  userAddWebProjectList: user.userAddWebProjectReducers,
  userEditProjectTimeList: user.userEditProjectTimeReducers,
  userAllReportDataList: user.userAllReportDataReducers,
  userAllUserStatusList: user.userAllUserStatusReducers,
  userDasboardList: user.userDasboardReducer,
  userWeekList: user.userWeekReducer,
  deleteProjectTimeList: user.deleteProjectTimeReducers,
  deleteProjectList: user.deleteProjectReducers,
  deleteTodoList: user.deleteTodoReducers,
  deleteScreenShotList: user.deleteScreenShotReducers,
  updateScreenShotList: user.updateScreenShotReducers,
  userResendEmailList: user.userResendEmailReducers,
  addUserSettingList: user.addUserSettingReducers,
  userAddTodoTimeReducers: user.userAddTodoTimeReducers,
  screenDashList: user.screenDashReducers,
  userDashTodayTimesList: user.userDashTodayTimesReducer,
  timeDashList: user.timeDashReducer,
  getUserAppTrackList: user.getUserAppTrackReducers,
  getUserAppTrackByDateList: user.getUserAppTrackByDateReducers,
  getUserSettingList: user.getUserSettingReducers,
  userRangeWiseTimeList: user.userRangeWiseTimeReducer,
  getUserMArkList: user.getUserMArkReducers,
  AddUserWorkingList: user.AddUserWorkingReducers,
  deleteLeaveInUserList: user.deleteLeaveInUserReducers,
  addLeaveInUserList: user.addLeaveInUserReducers,
  getLeaveInUserList: user.getLeaveInUserReducers,
  getLeaveSettingList: user.getLeaveSettingReducers,
  getLeaveByCompanyInManagerList: user.getLeaveByCompanyInManagerReducers,
  addApproveLeaveByManagerList: user.addApproveLeaveByManagerReducers,
  addRejectLeaveByManagerList: user.addRejectLeaveByManagerReducers,
  getCompanyOwnerList: user.getCompanyOwnerReducers,
  getUserCompaniesList: user.getUserCompaniesReducers,
  getUserPayrollList: user.getUserPayrollReducers,
  userRegisterWithPassList: user.userRegisterWithPassReducers,
  getUserAllCompanySettingList: user.getUserAllCompanySettingReducers,
  addUserTrainingList: user.addUserTrainingReducer,
  createUserRoleList: reducer_1.createUserRoleReducer,
  updateUserRoleList: reducer_1.updateUserRoleReducer,
  getUserRoleList: reducer_1.getUserRoleReducer,
  deleteUserRoleList: reducer_1.deleteUserRoleReducer,
  addPayrollProcessList: reducer_1.addPayrollProcessReducer,
  deletePayrollOfCompanyList: reducer_1.deletePayrollOfCompanyReducers,
  addCompanyModulesList: reducer_1.addCompanyModulesReducers,

  //Shared

  createDependentList: reducer_1.createDependentReducers,
  deleteDependentList: reducer_1.deleteDependentReducers,
  getDependentList: reducer_1.getDependentReducers,

  sendHRLetterList: reducer_1.sendHRLetterReducers,
  getHRLettersList: reducer_1.getHRLettersReducers,
  getCompanyAppsList: reducer_1.getCompanyAppsReducers,
  getAllowedAppsList: reducer_1.getAllowedAppsReducers,

  //update bulk

  adminUpdateBulkCompanyList: reducer_1.adminUpdateBulkCompanyReducers,

  //manager
  empDepAllActivityList: manager.empDepAllActivityReducers,
  empDepList: manager.empDepListReducers,
  empDepAllReportList: manager.empDepAllReportReducers,
  empDepDeleteProjectTimeList: manager.empDepDeleteProjectTimeReducers,
  empDepAllTimesheetList: manager.empDepAllTimesheetReducers,
  empDepEditTimeInProjectList: manager.empDepEditTimeInProjectReducers,
  empDepAddTimeInProjectList: manager.empDepAddTimeInProjectReducers,
  deleteDepEmpScreenShotList: manager.deleteDepEmpScreenShotReducers,
  updateDepEmpScreenShotList: manager.updateDepEmpScreenShotReducers,
  empDepTimeProDasboardSevenList: manager.empDepTimeProDasboardSevenReducers,
  empDepTimeProDasboardWeekList: manager.empDepTimeProDasboardWeekReducers,
  empDepAllCheckinList: manager.empDepAllCheckinReducers,
  empDepAllScreenList: manager.empDepAllScreenReducers,
  empDepAllTeamsList: manager.empDepAllTeamsReducers,
  screenShotDepList: manager.screenShotDepReducers,
  timeDepList: manager.timeDepReducer,
  userDepDasboardList: manager.userDepDasboardReducer,
  userDepWeekList: manager.userDepWeekReducer,
  getManagerPersonalList: manager.getManagerPersonalReducers,
  managerPersonalList: manager.managerPersonalReducers,
  ManagerChangeImageList: manager.ManagerChangeImageReducers,
  ManagerChangePasswordList: manager.ManagerChangePasswordReducers,
  ManagerUpdateDetailList: manager.ManagerUpdateDetailReducers,
  getDepSettingList: manager.getDepSettingReducers,
  projectDepDeleteList: manager.projectDepDeleteReducer,
  empDepInviteByEmailList: manager.empDepInviteByEmailReducers,
  sendDepEmpResetPassEmailList: manager.sendDepEmpResetPassEmailReducers,
  empDepUpdatDetailList: manager.empDepUpdatDetailReducers,
  empDepBlockFromDepartmentList: manager.empDepBlockFromDepartmentReducers,
  empDepAddInProjectList: manager.empDepAddInProjectReducers,
  getManagerAppTrackList: manager.getManagerAppTrackReducers,
  getManagerAppTrackByDateList: manager.getManagerAppTrackByDateReducers,
  getDeptAppTrackByDateList: manager.getDeptAppTrackByDateReducers,
  appTrackingSettingList: manager.appTrackingSettingReducers,
  getManagerEmpTotalTimeByRangeList:
    manager.getManagerEmpTotalTimeByRangeReducers,
  userDeleteFromProjectInManagerList:
    manager.userDeleteFromProjectInManagerReducer,
  getCompanyByPayloadSettingList: manager.getCompanyByPayloadSettingReducers,

  //recruitment

  getEmployeePdfList: reducer_1.getEmployeePdfReducer,
  candidateApplyList: reducer_1.candidateApplyReducer,
  deleteCompanyList: reducer_1.deleteCompanyReducer,
  deleteJobAdList: reducer_1.deleteJobAdReducer,
  getAllCandidatesList: reducer_1.getAllCandidatesReducer,
  getAllCompaniesList: reducer_1.getAllCompaniesReducer,
  getAllJobAdList: reducer_1.getAllJobAdReducer,
  getAllJobAdDetailsList: reducer_1.getAllJobAdDetailsReducer,
  getCandidateList: reducer_1.getCandidateReducer,
  getCompanyList: reducer_1.getCompanyReducer,
  getCompanyPublicList: reducer_1.getCompanyPublicReducer,
  getJobAdApplicationList: reducer_1.getJobAdApplicationReducer,
  getJobAdDetailsList: reducer_1.getJobAdDetailsReducer,
  getJobAdList: reducer_1.getJobAdReducer,
  getJobAdWorkflowList: reducer_1.getJobAdWorkflowReducer,
  updateRecruitCompanyList: reducer_1.updateRecuitCompanyReducer,
  updateJobAdApplicationList: reducer_1.updateJobAdApplicationReducer,
  updateJobAdDetailsList: reducer_1.updateJobAdDetailsReducer,
  updateJobAdStatusList: reducer_1.updateJobAdStatusReducer,
  updateJobAdWorkflowList: reducer_1.updateJobAdWorkflowReducer,
  getJobPublicList: reducer_1.getJobPublicReducer,
  updateCandidateNotesList: reducer_1.updateCandidateNotesReducer,
  updateCandidateStatusList: reducer_1.updateCandidateStatusReducer,
  addScreeningAnswerList: reducer_1.addScreeningAnswerReducer,
  updateRecruiterAssessmentList: reducer_1.updateRecruiterAssessmentReducer,
  updateCandidateRecruiterAssessmentList:
    reducer_1.updateCandidateRecruiterAssessmentReducer,
  addCandidateList: reducer_1.addCandidateReducer,
  uploadCandidateFilesList1: reducer_1.uploadCandidateFilesReducer1,
  uploadCandidateFilesParseList: reducer_1.uploadCandidateFilesParseReducer,
  archiveBulkCandidateList: reducer_1.archiveBulkCandidateReducer,
  assignJobToTalentPoolList: reducer_1.assignJobToTalentPoolReducer,
  getCandidateFromTalentPoolList: reducer_1.getCandidateFromTalentPoolReducer,
  updateBulkCandidateTalentPoolList:
    reducer_1.updateBulkCandidateTalentPoolReducer,
  updateCandidateTalentPoolList: reducer_1.updateCandidateTalentPoolReducer,
  updateOtpByEmailList: reducer_1.updateOtpByEmailReducers,
  resendOtpByEmailList: reducer_1.resendOtpByEmailReducers,
  getAllRecruitCompaniesList: reducer_1.getAllRecruitCompaniesReducer,
  getPaginatedJobAdList: reducer_1.getPaginatedJobAdReducer,
  getPaginatedJobFiltersList: reducer_1.getPaginatedJobFiltersReducer,

  createStatusesTemplateList: reducer_1.createStatusesTemplateReducer,
  deleteStatusesTemplateList: reducer_1.deleteStatusesTemplateReducer,
  getAllStatusesTemplatesList: reducer_1.getAllStatusesTemplatesReducer,
  updateStatusesTemplateList: reducer_1.updateStatusesTemplateReducer,
  //Testing

  updateDocumentStatusList: reducer_1.updateDocumentStatusReducer,
  createDocumentTemplateList: reducer_1.createDocumentTemplateReducer,
  createMultipleDocumentTemplateList:
    reducer_1.createMultipleDocumentTemplateReducer,
  updateDocumentTypeList: reducer_1.updateDocumentTypeReducer,
  updateDocumentTemplateList: reducer_1.updateDocumentTemplateReducer,
  getAllDocumentTemplateList: reducer_1.getAllDocumentTemplateReducer,
  deleteDocumentTemplateList: reducer_1.deleteDocumentTemplateReducer,
  createUserDocumentReducersList: reducer_1.createUserDocumentReducers,
  updateUserDocumentReducersList: reducer_1.updateUserDocumentReducers,
  updateChangeUserDocumentList: reducer_1.updateChangeUserDocumentReducers,
  getAllUserDynamicDocumentsList: reducer_1.getAllUserDynamicDocumentsReducers,

  adminAddUserImportCompanyUploadList:
    reducer_1.adminAddUserImportCompanyUploadReducers,

  createOnboardingTemplateList: reducer_1.createOnboardingTemplateReducer,
  assignOnboardingTemplateList: reducer_1.assignOnboardingTemplateReducer,
  deleteOnboardingTemplateList: reducer_1.deleteOnboardingTemplateReducer,
  getAllOnboardingTemplatesList: reducer_1.getAllOnboardingTemplatesReducer,
  getOnboardingTemplatesList: reducer_1.getOnboardingTemplatesReducer,
  updateOnboardingTemplateList: reducer_1.updateOnboardingTemplateReducer,

  //create User

  //Entity Management
  createUserList: reducer_1.createUserReducer,
  updateUserList: reducer_1.updateUserReducer,
  updateUserAuthList: reducer_1.updateUserAuthReducer,
  getOneUserList: reducer_1.userReducer,
  getOneAuthUserList: reducer_1.userAuthReducer,
  getALLUserList: reducer_1.getAllUserReducer,

  updateUserStatus: reducer_1.updateUserStatusReducer,
  //Entity Management
  createEntityList: reducer_1.createReducer,
  getAllEntityList: reducer_1.getAllEntityReducer,
  getSingleEntityList: reducer_1.getSingleEntityReducer,
  updateEntityOverviewList: reducer_1.updateEntityOverviewReducer,
  updateEntityFormatsList: reducer_1.updateEntityFormatsReducer,
  getEntityFormatsList: reducer_1.getEntityFormatsReducer,
  createEntityFormatsList: reducer_1.createEntityFormatsReducer,
  addEntityComments: reducer_1.addEntityCommentsReducer,
  getEntityComments: reducer_1.getEntityCommentsReducer,
  getEntityActivityLogs: reducer_1.getEntityActivityLogsReducer,

  getAllEntity: reducer_1.getAllEntityWithoutPaginationReducer,
  getAllDimension: reducer_1.getDimensionReducer,
  // Dimenstions
  createDimensionList: reducer_1.createDimensionReducer,
  getAllDimensionList: reducer_1.getAllDimensionReducer,
  getSingleDimensionList: reducer_1.getSingleDimensionReducer,
  setStatusActionOfDimensionList: reducer_1.setStatusActionOfDimensionReducer,
  setDimensionsPathHierarchyList: reducer_1.setDimensionsPathHierarchyReducer,
  updateDimensionsPathHierarchyList:
    reducer_1.updateDimensionsPathHierarchyReducer,
  assignMultipleUsersToDimensionList:
    reducer_1.assignMultipleUsersToDimensionReducer,
  getAllUsersToDimensionList: reducer_1.getAllUsersToDimensionReducer,
  updateDimensionList: reducer_1.updateDimensionReducer,
  getOverallDimensionHierarchyList:
    reducer_1.getOverallDimensionHierarchyReducer,
  getHierarchyByTypeList: reducer_1.getHierarchyByTypeReducer,
  updateEntityStatusList: reducer_1.updateEntityStatusReducer,
  getFormBuilderList: reducer_1.getFormBuilderReducer,
  createFormBuilderList: reducer_1.createFormBuilderReducer,
  getClientFormBuilderList: reducer_1.getClientFormBuilderReducer,
  uploadDocumentCustomerDynamicFormList:
    reducer_1.uploadDocumentCustomerDynamicFormReducer,
  updateClientFormBuilderList: reducer_1.updateClientFormBuilderReducer,
  getCustomerIdList: reducer_1.getCustomerIdReducer,
  //Testing
  createPublicHolidaysList: reducer_1.createPublicHolidaysReducer,
  updatePublicHolidaysList: reducer_1.updatePublicHolidaysReducer,
  getOnePublicHolidaysList: reducer_1.getOnePublicHolidaysReducer,
  getAllPublicHolidaysList: reducer_1.getAllPublicHolidaysReducer,
  deletePublicHolidaysList: reducer_1.deletePublicHolidaysReducer,

  duplicateJobAdList: reducer_1.duplicateJobAdReducer,
  updateTemplateIdToJobAdList: reducer_1.updateTemplateIdToJobAdReducer,
  createEmailTemplateList: reducer_1.createEmailTemplateReducer,
  deleteEmailTemplateList: reducer_1.deleteEmailTemplateReducer,
  getAllEmailTemplateList: reducer_1.getAllEmailTemplateReducer,
  updateEmailTemplateList: reducer_1.updateEmailTemplateReducer,
  AddJobPostIdList: reducer_1.AddJobPostIdReducer,
  getDashboardWidgetList: reducer_1.getDashboardWidgetReducers,
  addDashboardWidgetList: reducer_1.addDashboardWidgetReducers,
  getDashboardRecruitmentList: reducer_1.getDashboardRecruitmentReducers,
  getActivityOverviewList: reducer_1.getActivityOverviewReducers,
  changingTokenList: reducer_1.changingTokenReducers,

  employeeLateComingRangeReportList:
    reducer_1.employeeLateComingRangeReportReducers,

  addBulkShiftList: reducer_1.addBulkShiftReducers,

  addLateTimeList: reducer_1.addLateTimeReducers,
  getLateTimeList: reducer_1.getLateTimeReducers,

  getOvertimeSettingsList: reducer_1.getOvertimeSettingsReducer,
  overtimeSettingsEnableList: reducer_1.overtimeSettingsEnableReducer,

  getAllLateTimeList: reducer_1.getAllLateTimeReducer,
  shiftToCheckinList: reducer_1.shiftToCheckinReducer,

  saveUserLateTimeList: reducer_1.saveUserLateTimeReducer,
  addCompanyLeaveApproverSettList:
    reducer_1.addCompanyLeaveApproverSettReducers,
  addCompanyExpenseApproverSettList:
    reducer_1.addCompanyExpenseApproverSettReducers,
  addCompanyLeaveCalenderSettList:
    reducer_1.addCompanyLeaveCalenderSettReducers,
  addCompanyLeaveReasonSettList: reducer_1.addCompanyLeaveReasonSettReducers,

  addJobBoardLinkList: reducer_1.addJobBoardLinkReducers,
  getJobBoardLinkList: reducer_1.getJobBoardLinkReducers,

  getAllOnboardingTasksList: reducer_1.getAllOnboardingTasksReducer,
  taskCompletedList: reducer_1.taskCompletedReducer,
  getAllBulkImportsList: reducer_1.getAllBulkImportsReducers,

  createCustomFieldTemplateList: reducer_1.createCustomFieldTemplateReducers,
  deleteCustomFieldTemplateList: reducer_1.deleteCustomFieldTemplateReducers,
  getAllCustomFieldTemplateList: reducer_1.getAllCustomFieldTemplateReducers,
  updateOneCustomFieldList: reducer_1.updateOneCustomFieldReducers,

  getCompanyPolicyList: reducer_1.getCompanyPolicyReducer,
  createCompanyPolicyList: reducer_1.createCompanyPolicyReducer,
  updateCompanyPolicyList: reducer_1.updateCompanyPolicyReducer,
  deleteCompanyPolicyList: reducer_1.deleteCompanyPolicyReducer,
  deleteCompanyPolicyDocList: reducer_1.deleteCompanyPolicyDocReducer,

  // new leave

  createNewLeaveTypeList: reducer_1.createNewLeaveTypeReducer,
  getNewLeaveTypeList: reducer_1.getNewLeaveTypeReducer,
  archiveNewLeaveTypeList: reducer_1.archiveNewLeaveTypeReducer,
  updateNewLeaveTypeList: reducer_1.updateNewLeaveTypeReducer,
  updateNewLeaveTypeStatusList: reducer_1.updateNewLeaveTypeStatusReducer,
  downloadLeaveRequestPdfList: reducer_1.downloadLeaveRequestPdfReducer,
  downloadPublicHolidayXlsxList: reducer_1.downloadPublicHolidayXlsxReducer,
  downloadPublicHolidayCsvList: reducer_1.downloadPublicHolidayCsvReducer,

  // Email Signarture Generator

  createEmailSignatureList: reducer_1.createEmailSignatureReducer,
  updateEmailSignatureList: reducer_1.updateEmailSignatureReducer,
  getAllEmailSignatureList: reducer_1.getAllEmailSignatureReducer,
  deleteEmailSignatureList: reducer_1.deleteEmailSignatureReducer,
  getCompanyHierarchyList: reducer_1.getCompanyHierarchyReducers,
  getDepartmentHierarchyList: reducer_1.getDepartmentHierarchyReducers,
  changeCompanyHierarchyList: reducer_1.changeCompanyHierarchyReducers,

  //company attendance status

  archiveCompanyAttendanceStatusesList:
    reducer_1.archiveCompanyAttendanceStatusesReducers,
  archiveUserAttendanceStatusesList:
    reducer_1.archiveUserAttendanceStatusesReducers,
  createCompanyAttendanceStatusesList:
    reducer_1.createCompanyAttendanceStatusesReducers,
  getAllCompanyAttendanceStatusesList:
    reducer_1.getAllCompanyAttendanceStatusesReducers,
  getAllUserAttendanceStatusesList:
    reducer_1.getAllUserAttendanceStatusesReducers,
  updateCompanyAttendanceStatusesList:
    reducer_1.updateCompanyAttendanceStatusesReducers,
  //report download
  checkinReportDownloadList: reducer_1.checkinReportDownloadReducers,
  getDownloadedReportsList: reducer_1.getDownloadedReportsReducers,
  updateDownloadHistoryList: reducer_1.updateDownloadHistoryReducers,

  //helpdesk
  addCommentList: reducer_1.addCommentReducer,
  archiveTicketList: reducer_1.archiveTicketReducer,
  createTicketList: reducer_1.createTicketReducer,
  getAllTicketsList: reducer_1.getAllTicketsReducer,
  getCommentForOneTicketList: reducer_1.getCommentForOneTicketReducer,
  updateTicketList: reducer_1.updateTicketReducer,
  deleteCommentList: reducer_1.deleteCommentReducer,

  //traveldesk
  getAllTravelTicketsList: reducer_1.getAllTravelTicketsReducer,
  archiveTravelTicketList: reducer_1.archiveTravelTicketReducer,
  createTravelTicketList: reducer_1.createTravelTicketReducer,
  updateTravelTicketList: reducer_1.updateTravelTicketReducer,
  addTravelCommentList: reducer_1.addTravelCommentReducer,
  getCommentForOneTravelTicketList:
    reducer_1.getCommentForOneTravelTicketReducer,
  deleteTravelCommentList: reducer_1.deleteTravelCommentReducer,
  //contact support
  contactSupportList: reducer_1.contactSupportReducers,
  themeDefault: reducer_1.themeReducer,
  themeCreateList: reducer_1.themeCreateReducer,
  //notification
  notificationsUpdateList: reducer_1.NotificationUpdateReducers,
  notificationsList: reducer_1.NotificationGetReducers,
  contactSupportEmailList: reducer_1.contactSupportEmailReducers,

  //expense

  addExpenseOfUsersList: reducer_1.addExpenseOfUsersReducers,
  approveExpenseRequestList: reducer_1.approveExpenseRequestReducers,
  getAllExpenseRequestList: reducer_1.getAllExpenseRequestReducers,
  getAllExpenseHistoryList: reducer_1.getAllExpenseHistoryReducers,
  deleteExpenseRequestList: reducer_1.deleteExpenseRequestReducers,
  rejectExpenseRequestList: reducer_1.rejectExpenseRequestReducers,
  supportCard: reducer_1.supportCardReducer,
  // Language Translators
  getLanguageTranslatorList: reducer_1.getLanguageTranslatorReducer,
  breadCrumbsList: reducer_1.breadCrumbsReducer,
  //notification
  toggleDrawerList: reducer_1.toggleDrawerReducer,
  toggleUserTabSwitchList: reducer_1.toggleUserTabSwitchReducer,
  employeeLeaveAddStepperList: reducer_1.employeeLeaveAddStepperReducers,

  getAllPerformanceList: reducer_1.getAllPerformanceReducer,
  createPerformanceList: reducer_1.createPerformanceReducer,
  updatePerformanceList: reducer_1.updatePerformanceReducer,
  addPerformanceCommentList: reducer_1.addPerformanceCommentReducer,
  updatePerformanceCommentList: reducer_1.updatePerformanceCommentReducer,
  getCommentForOnePerformanceList: reducer_1.getCommentForOnePerformanceReducer,
  deletePerformanceCommentList: reducer_1.deletePerformanceCommentReducer,
  shiftConflictList: reducer_1.shiftConflictReducers,
  bulkShiftAssignList: reducer_1.bulkShiftAssignReducers,
  individualLeaveApproversList: reducer_1.individualLeaveApproversReducers,
  //trade license
  allTradeLicenseList: reducer_1.getAllTradeLicenseReducer,
  updateTradeLicenseList: reducer_1.updateTradeLicenseReducer,
  archiveTradeLicenseList: reducer_1.archiveTradeLicenseReducer,
  createTradeLicenseList: reducer_1.createTradeLicenseReducer,
  bulkAssignTradeLicenseList: reducer_1.bulkAssignTradeLicenseReducer,
  deleteTradeLicenseList: reducer_1.deleteTradeLicenseReducer,
  deleteExpiredTradeLicenseList: reducer_1.deleteExpiredTradeLicenseReducer,
  //employee designations updateEmployeeDesignationReducer
  allEmployeeDesignationList: reducer_1.getAllEmployeeDesignationReducer,
  updateEmployeeDesignationList: reducer_1.updateEmployeeDesignationReducer,
  createEmployeeDesignationList: reducer_1.createEmployeeDesignationReducer,
  deleteEmployeeDesignationList: reducer_1.deleteEmployeeDesignationReducer,
  bulkAssignEmployeeDesignationList:
    reducer_1.bulkAssignEmployeeDesignationReducer,
  getLeaveByUserList: reducer_1.getLeaveByUserReducers,

  getAllPayslipList: reducer_1.getAllPayslipReducer,
  createPayslipList: reducer_1.createPayslipReducer,
  updatePayslipList: reducer_1.updatePayslipReducer,
  deletePayslipList: reducer_1.deletePayslipReducer,
  getOnePayslipList: reducer_1.getOnePayslipReducer,
  updatePayslipStatusList: reducer_1.updatePayslipStatusReducer,
  limitedNotifications: reducer_1.limitedNotificationsReducer,
  limitedAnnouncement: reducer_1.limitedAnnouncementReducer,
  allLeaves: reducer_1.getAllLeaveReducer,
  checkOut: reducer_1.getCheckOutReducer,
  checkIn: reducer_1.getCheckInReducer,
  getAllModulesList: getAllModulesReducer,
  saveEntityModulesList: saveEntityModulesReducer,
  getEntityModulesList: getEntityModulesReducer,

  tokenInfoList: reducer_1.tokenInfoReducers,

  createSupportMessageList: reducer_1.createSupportMessageReducers,
  createSupportTicketList: reducer_1.createSupportTicketReducers,
  getAllSupportTicketList: reducer_1.getAllSupportTicketReducers,
  getSupportMessageByTicketIdList:
    reducer_1.getSupportMessageByTicketIdReducers,
  getSupportTicketByIdList: reducer_1.getSupportTicketByIdReducers,
  updateSupportTicketList: reducer_1.updateSupportTicketReducers,
  getAllCompanySupportList: reducer_1.getAllCompanySupportTicketReducers,

  adminCreateSupportMessageList: reducer_1.adminCreateSupportMessageReducers,
  adminGetSupportMessageByTicketIdList: reducer_1.adminGetSupportMessageByTicketIdReducers,
  adminGetSupportTicketByIdList: reducer_1.adminGetSupportTicketByIdReducers,
  adminUpdateSupportTicketList: reducer_1.adminUpdateSupportTicketReducers,
});

const sharedInfoFromLocalStorage = localStorage.getItem("sharedUserInfo")
  ? JSON.parse(localStorage.getItem("sharedUserInfo"))
  : null;

const initialState = {
  sharedLogin: { sharedUserInfo: sharedInfoFromLocalStorage },
  // theme: initialTheme,
};

const middleware = [thunk];

const rootReducer = (state, action) => {
  if (action.type === SHARED_LOGOUT) {
    // Reset the entire state to initialState
    state = undefined;
  }
  if (action.type === ADMIN_OPEN_ANOTHER_COMPANY_LIST_SUCCESS) {
    // Reset the entire state to initialState
    const shared = state.sharedLogin;
    // const theme = state.themeDefault;
    state = {};
    state.sharedLogin = shared;
    state.themeDefault = initialTheme;
  }
  return reducer(state, action);
};

const Store = createStore(
  rootReducer,
  initialState,
  composeWithDevTools(applyMiddleware(...middleware)),
);

export default Store;
